import { Component } from '@angular/core';

/**
 * NUC-179: TaskSense thin shell over @nucleus/connector-admin-ui. The list +
 * edit page live in the shared lib (<lib-connector>). As of connector-admin-ui
 * 0.0.3 the editor is a sibling route (connectors/new, connectors/:id), so the
 * tenant notifier adapter (CONNECTOR_NOTIFIER), OpenAPI client and
 * CAPABILITY_CHECKER are all provided at root (app.module.ts) — the routed edit
 * page no longer inherits component-level providers. Mirror of TaskSense's
 * ReferenceDataComponent.
 */
@Component({
  selector: 'connectors',
  templateUrl: './connectors.component.html',
  styleUrl: './connectors.component.css',
  standalone: false
})
export class ConnectorsComponent { }
